// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    hmr: false,
    apiUrl: "/api",
    // apiUrl: "http://localhost:9001",
    token: "",
    refresh_token: "",
    tokenTTL: ""
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/environments/environment.ts